export const DEFAULT_NUMBER_LOCALE = 'en-AU'

export const formatNumberForLocale = (
  value,
  options,
  locale = DEFAULT_NUMBER_LOCALE
) => Number(value).toLocaleString(locale, options)
